module.exports = "/_next/static/images/Rig-1b5dbbafd9780c39fbafb3a74bcab0a9.png";